import React from 'react'

const OrderCards = ({ order, currentStep }) => {
    return (
        <>
            <div className="order-card d-flex flex-column flex-md-row gap-3">
                {/* Product Image */}
                <img src={order.image} alt="product" className="order-image" />

                <div className='d-flex justify-content-between flex-column'>
                    {/* Title & Price */}
                    <div className="flex-grow-1 order_detail">
                        <p className="m-0 fw-medium">{order.title}</p>
                        <h6 className="fw-bold mt-2">{order.price} $</h6>
                    </div>
                    {/* Buttons */}
                    <div className="d-flex gap-2">
                        <button className="btn btn-track yellow_btn">Track Order</button>
                        <button className="btn btn-cancel">Cancel Order</button>
                    </div>
                </div>

                <div className="order-status-bar d-flex justify-content-between hide_on_1400">
                    {order.steps.map((step, index) => (
                        <div key={step} className="step-container">
                            <div
                                className={`step-circle ${index <= currentStep ? 'active' : ''
                                    }`}
                            ></div>
                            <div className="step-label">{step}</div>
                            {index < order.steps.length - 1 && (
                                <div className={`step-line ${index < currentStep ? 'active' : ''}`} />
                            )}
                        </div>
                    ))}
                </div>


            </div>
        </>
    )
}

export default OrderCards